const styles = theme => ({
  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  representativeCardsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      gap: '16px',
    },
  },

  representativeCard: {
    width: '100%',
    padding: '24px',
    backgroundColor: theme.palette.primary.white,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    boxShadow: 'none',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },

  selectedRepresentativeCard: {
    backgroundColor: theme.palette.primary.adgmGreenLight,
  },

  nameAndIconHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },

  nameHolder: {},

  representativeCardRadioButton: {
    padding: 0,
    '& input:checked + div': {
      color: theme.palette.primary.adgmGreenDark,
    },
  },

  representativeDetailsHolder: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },

  representativeDetail: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderTop: `1px solid ${theme.palette.primary.borderColor}`,
      padding: '16px 24px',
    },
  },

  pagination: {
    marginTop: '24px',
  },

  noDataFoundHolder: {
    [theme.breakpoints.down('sm')]: {
      padding: '16px 24px',
    },
  },
});

export default styles;
